import { render, staticRenderFns } from "./workGroupEdit.vue?vue&type=template&id=0f71a5fd&"
import script from "./workGroupEdit.vue?vue&type=script&lang=js&"
export * from "./workGroupEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports